import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl-next';

import { ErrorMessage, HelperMessage } from '@atlaskit/form';
import EditorInfoIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { messages } from '../i18n';

import * as Styled from './styled';
export function InfoDetailLearnMoreLink(): React.JSX.Element {
	return (
		<Styled.InfoPopupLearnMoreWrapper>
			{/* eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlaskit/design-system/no-html-anchor */}
			<a target="_blank" rel="noreferrer" href="#">
				<FormattedMessage {...messages.learnMore} />
			</a>
		</Styled.InfoPopupLearnMoreWrapper>
	);
}
export function TeamNameErrorMsg({ errorMsg }: { errorMsg: string }): React.JSX.Element {
	return <ErrorMessage testId="team-name-empty-error">{errorMsg}</ErrorMessage>;
}
export function TeamNameInfoMsg(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<HelperMessage testId="team-name-info-msg" aria-hidden="true">
			<Styled.DivWrapper>
				<FormattedMessage {...messages.teamNameFieldInfoMessage} />
				<Tooltip content={formatMessage(messages.teamNameFieldInfoDetail)}>
					<Styled.InfoIconWrapper tabIndex={0} role="button">
						<EditorInfoIcon
							label={formatMessage(messages.teamNameFieldInfoDetail)}
							LEGACY_size="small"
							color="currentColor"
							LEGACY_margin={token('space.050', '4px')}
							size="small"
						/>
					</Styled.InfoIconWrapper>
				</Tooltip>
			</Styled.DivWrapper>
		</HelperMessage>
	);
}
